module.exports = "nb-tabset nb-tab.content-active {\n  padding-top: 1.5rem;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex; }\n  nb-tabset nb-tab.content-active .btn {\n    width: 33.33%;\n    margin-right: 1rem;\n    padding: 1.4rem 1.5rem; }\n  nb-tabset nb-tab.content-active .btn:last-child {\n      margin-right: inherit; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/kasko-new/modal-client-type/modal-client-type.component.scss
// module id = ./src/app/kasko-new/modal-client-type/modal-client-type.component.scss
// module chunks = main